import { render, staticRenderFns } from "./Daily_New_account.vue?vue&type=template&id=9f6254a4&scoped=true"
import script from "./Daily_New_account.vue?vue&type=script&lang=js"
export * from "./Daily_New_account.vue?vue&type=script&lang=js"
import style0 from "./Daily_New_account.vue?vue&type=style&index=0&id=9f6254a4&prod&lang=css"
import style1 from "./Daily_New_account.vue?vue&type=style&index=1&id=9f6254a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6254a4",
  null
  
)

export default component.exports